<template>
  <v-card height="200">
    <v-card-text style="position: relative;" class="align-self-stretch">
      <!--    -->
      <v-row v-if="loading" style="position: absolute; left: 12px; top:50px; width: 100%; height: 100%;" justify="center" align="center">
        <v-progress-circular indeterminate color="accent" size="64"/>
      </v-row>
      <v-row v-else style="position: absolute; left: 12px; top:0px; bottom: 0; right: 12px" >
        <v-col :cols="12">
          <v-row class="d-flex">
            <div class="mx-auto headline mt-n1"><span class="text-center">{{title}}</span></div>
          </v-row>
          <v-row class="d-flex justify-space-between mt-2">
            <div class="d-flex my-auto ml-3" style="width: 50px;" ></div>
            <div class style="font-size: 100px; height: 100px;" class="font-weight-light">
              <div class="mt-8">
                {{index ? Math.round(index) : 0}}
              </div>
            </div>
            <div class="d-flex my-auto mr-3" style="width: 50px;" >
              <v-icon size="40">{{wohlbefindenIcon}}</v-icon>
            </div>
          </v-row>
          <v-row class="justify-space-around mt-n2 px-5" style="min-height: 22px;">
            <span>{{indexDetails}}</span>
          </v-row>
          <v-row class="mx-3 mt-3" style="background-color: #ebebeb; height: 10px;">
            <div class="d-flex" :style="'background-color: #ffca37; flex-grow: '+((index||0)/100)"></div>
            <div class="d-flex" style=""></div>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>

import Kinds from "@/components/Kinds";

const {DateTime} = require("luxon");
import {round} from "@/reusable/numbers";
import Bereiche from "@/components/Bereiche";

export default {
  name: "TeamIndexWeek",
  components: { },
  props: ['treenode', 'loading', 'date', ],
  data() {
    return {
      woche:"diese Woche",
      availability:[],
      happyness: 0,
      index: 0,
      isTeam:false,
      title:undefined,
      indexDetails:undefined,
      checkMo:false,
      checkDi:false,
      checkMi:false,
      checkDo:false,
      checkFr:false,
      checkSa:false,
      checkSo:false,
      disabledMo:true,
      disabledDi:true,
      disabledMi:true,
      disabledDo:true,
      disabledFr:true,
      disabledSa:true,
      disabledSo:true,
      todayMo:false,
      todayDi:false,
      todayMi:false,
      todayDo:false,
      todayFr:false,
      todaySa:false,
      todaySo:false,
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    load(){
      if (!this.date)
        return;
      var dateTime=DateTime.local();
      if (this.date)
        dateTime=DateTime.fromJSDate(this.date);
      this.weekDate=dateTime.setLocale("de").startOf("week");
      var mo=this.weekDate;
      var so=this.weekDate.plus({'days':6});
      console.log("index week: " + this.weekDate.toISODate())
      var today=DateTime.fromJSDate(new Date(Date.now()));
      //var today=DateTime.fromISO("2020-11-23")
      var diff=today.diff(this.weekDate, 'days').days;
      console.log({diff, dateTime, today})
      if (diff < -1 || diff > 6)
        this.woche=`${mo.day}.${mo.month}. - ${so.day}.${so.month}.`;
      else
        this.woche="diese Woche"
      this.disabledMo=diff<0;
      this.disabledDi=diff<1;
      this.disabledMi=diff<2;
      this.disabledDo=diff<3;
      this.disabledFr=diff<4;
      this.disabledSa=diff<5;
      this.disabledSo=diff<6;
      this.loadAvailability();
    },
    async loadAvailability() {
      var id = this.date.toISOString().substr(0, 7); // YYYY-MM
      this.availability=(await this.$backend.get_object(Kinds.KIND_RECORD_AVAILABILITY, id)) || {};
      this.checkMo=this.check(0);
      this.checkDi=this.check(1);
      this.checkMi=this.check(2);
      this.checkDo=this.check(3);
      this.checkFr=this.check(4);
      this.checkSa=this.check(5);
      this.checkSo=this.check(6);
    },
    check(day) {
      return this.availability[this.weekDate.plus({ days: day }).toISODate()]==true;
    },
    gotoEingabe(day) {
      this.$router.push("/eingabe/"+this.weekDate.plus({ days: day }).toISODate());
    },
    gotoPrevWeek() {
      this.$router.replace("/dashboard/"+(this.weekDate.plus({ days: -7 }).toISODate()));
    },
    gotoNextWeek() {
      this.$router.replace("/dashboard/"+(this.weekDate.plus({ days: 7 }).toISODate()));
    },
    dayColor(day) {
      if (!this.weekDate)
        return null;
      var today=DateTime.fromJSDate(new Date(Date.now()));
      if (this.weekDate.plus({'days':day}).toISODate() == today.toISODate())
        return "blue--text";
      return null;
    }
  },
  computed: {
    wohlbefindenIcon() {
      var happyness=this.happyness;
      console.log({happyness});
      if (happyness >= 2)
        return 'mdi-emoticon-outline';
      if (happyness >= 1)
        return 'mdi-emoticon-happy-outline';
      if (happyness >= 0)
        return 'mdi-emoticon-neutral-outline';
      if (happyness >= -1)
        return 'mdi-emoticon-sad-outline';
      if (happyness < -1)
        return 'mdi-emoticon-cry-outline';
      return 'mdi-emoticon-neutral-outline';
    }
  },
  watch: {
    date() {
      this.load();
    },
    treenode: {
      deep:true,
      handler(n) {
        if (!n)
          return;
        this.title = n.name;
        this.indexDetails=" ";
        if (n.index!==undefined) {
          this.isTeam=false;
          this.index = n.index.index || 0;
          this.happyness = n.index.happyness || 0;
        } else if (n.teamIndex!==undefined) {
          this.isTeam=true;
          var eigen=Math.round(n.teamIndex["own/index"] || 0);
          var team=Math.round(n.teamIndex["team/index"] || 0);
          var total=Math.round(n.teamIndex["total/index"] || 0);
          this.index = total;
          this.happyness = n.teamIndex["total/happyness"] || 0;
          this.indexDetails= `Eigen: ${eigen}   Team: ${team}`
        } else {
          this.isTeam=false;
          this.index = 0;
          this.happyness = 0;
        }
      }
    }
  }
}
</script>

<style scoped>

</style>